import React from "react";
import { CalendarDaysIcon, CheckIcon } from "lucide-react";
import { Accent, Container, SectionHeader } from "./ui";
import { book, images } from "../data/content";
export function BookSection() {
  return <section className="bg-cream py-12 md:py-24" data-id="element-14" data-mp="2k8d5noepn42v">
      <Container data-id="element-15" data-mp="2k4xngcpqpex8">
        <SectionHeader eyebrow="Inside the kit" title={<>
              One book. <Accent data-id="element-17" data-mp="3by7y3txv79vr">{book.activityCount} ready-to-lead activities.</Accent>
            </>} lead="Each activity comes with the materials to print and the instructions to lead it." data-id="element-16" data-mp="2f8h03kqd74l7" />

        <article className="grid grid-cols-1 items-center gap-8 rounded-2xl border border-line bg-white p-5 shadow-[0_12px_32px_rgba(22,78,85,0.07)] md:grid-cols-[minmax(0,340px)_1fr] md:gap-12 md:p-8" data-id="element-18" data-mp="32x9x7kiq3ihe">
          <img src={images.bookCover} alt="Cover of Volume 01 — Group Games & Social Fun" className="mx-auto h-auto w-full max-w-[300px] rounded-lg border border-line shadow-[0_16px_36px_rgba(22,78,85,0.14)]" data-id="element-19" data-mp="1riwf6wanhx9a" />
          <div data-id="element-20" data-mp="26blod8pj3kx">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-21" data-mp="69ho19sp8am4">{book.label}</p>
            <h3 className="mt-2 font-display text-[32px] font-bold uppercase leading-none text-petrol sm:text-[40px]" data-id="element-22" data-mp="3ofmje6895fou">
              {book.title}
            </h3>
            <p className="mt-4 text-base text-muted sm:text-lg" data-id="element-23" data-mp="3tcmityaljk6z">{book.description}</p>

            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-24" data-mp="3eo049yssmwgt">
              {book.features.map(f => <li key={f} className="rounded-md bg-sage px-3 py-1.5 text-sm font-semibold text-petrol" data-id="element-25" data-mp="3jhul8uh0kxc7">
                  {f}
                </li>)}
            </ul>

            <h4 className="mt-8 text-sm font-semibold uppercase tracking-[0.16em] text-ink" data-id="element-26" data-mp="3aor8ypi3uqj5">Activities include</h4>
            <ul className="mt-3 divide-y divide-line border-y border-line" data-id="element-27" data-mp="2vr8lrrl2sldt">
              {book.sampleActivities.map(a => <li key={a.code} className="flex items-center gap-4 py-3" data-id="element-28" data-mp="30rmjafp1wcxl">
                  <span className="w-12 shrink-0 font-display text-xl font-bold text-petrol" data-id="element-29" data-mp="2hmhrqy9nh7k2">{a.code}</span>
                  <span className="text-ink" data-id="element-30" data-mp="2csdho6538jer">{a.name}</span>
                  <CheckIcon className="ml-auto h-4 w-4 shrink-0 text-petrol" strokeWidth={3} aria-hidden="true" data-id="element-31" data-mp="27weycwym9rl7" />
                </li>)}
            </ul>
          </div>
        </article>

        <article className="mt-6 flex flex-col gap-5 rounded-2xl bg-sage p-6 sm:flex-row sm:items-center md:p-8" data-id="element-32" data-mp="30izro2ynkdre">
          <span className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-white text-petrol" data-id="element-33" data-mp="2vlhf82lffgen">
            <CalendarDaysIcon className="h-7 w-7" aria-hidden="true" data-id="element-34" data-mp="2qny2560gt9oa" />
          </span>
          <div data-id="element-35" data-mp="2lmifj9in2v3s">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-petrol" data-id="element-36" data-mp="2louynq04vbif">Included in the kit</p>
            <h3 className="mt-1 font-display text-[30px] font-bold uppercase leading-none text-petrol" data-id="element-37" data-mp="1a7lc2ulpk3cw">
              The 12-month activity calendar
            </h3>
            <p className="mt-2 max-w-[680px] text-ink" data-id="element-38" data-mp="3lwjf9jlj4o89">
              Plan when to run your sessions across the year. Use it alongside your community’s existing daily program
              and care guidance.
            </p>
          </div>
        </article>
      </Container>
    </section>;
}